import {DprApiImage} from "../ApiImage";
import React from "react";
import {IEditor} from "@webng-types/write-model/index";
import {useTrackingFunction} from "../LiveblogRenderContext";

export interface EventAuthorProps {
  className?: string
  editor: IEditor
  showByline?: boolean
  isFallback?: boolean
}

export function EventAuthor({className, editor, showByline, isFallback}: EventAuthorProps) {
  const currentEditorImage = !isFallback ? (editor.local_image ?? editor.image) : (editor.image ?? editor.local_image)
  const currentEditorName = !isFallback ? (editor.local_name ?? editor.name) : (editor.name ?? editor.local_name)
  const currentEditorByline = !isFallback ? (editor.local_byline ?? editor.byline) : (editor.byline ?? editor.local_byline)

  const trackingFunction = useTrackingFunction();
  const onClick = React.useCallback(() => {
    trackingFunction({t: "a_eap", url: editor.ext_profile_url?.slice(0,256), ts: Date.now()});
  }, [trackingFunction, editor.ext_profile_url]);

  const WrapperTag = editor.ext_profile_url ? 'a' : 'div';
  const wrapperProps = editor.ext_profile_url ? { href: editor.ext_profile_url, target: '_blank', rel: 'noopener', onClick } : {};

  return <div className={className || 'tik4-author'}>
    <WrapperTag className="tik4-author__wrapper" {...wrapperProps}>
      <div className="tik4-author__name">
        <div className="tik4-author__name__t">
          {editor.name}
        </div>
        {currentEditorByline && showByline &&
          <div className="tik4-author__name__bl">
            {currentEditorByline}
          </div>
        }
      </div>
      { currentEditorImage &&
        <div className="tik4-author__thumb">
          <DprApiImage
              className="tik4-author__thumb__img"
              alt={currentEditorName}
              image={currentEditorImage}
              width={64}
              height={64}
              fit="cover"
              />
        </div>
      }
    </WrapperTag>
  </div>;
}

